import React, { useState, useContext, useEffect } from "react";
import getProfileLabel from "../genericFunctions/getProfileLabel";
import { useHistory } from "react-router-dom";
import HobbyItem from "./HobbyItem";
import { AuthContext } from "../context/AuthContext";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import CloseIcon from "@material-ui/icons/Close";

const Hobbies = (props) => {
  const [hobby, setHobby] = useState({ name: "" });
  const hobbies = props.hobbies;
  const [editing, setEditing] = useState(false);
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const onSubmitHobbies = props.onSubmitHobbies;
  const handleRemoveHobby = props.handleRemoveHobby;
  const [inputError, setInputError] = useState({
    state: false,
    message: "",
  });

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      history.push("/login");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onChange = (e) => {
    setHobby({ name: e.target.value });
  };
  const onSubmitValidation = (e) => {
    e.preventDefault();
    if (hobby.name === "") {
      setInputError({ state: true, message: "Please enter a hobby" });
    } else {
      setInputError({ state: false, message: "" });
      onSubmitHobbies(e, hobby);
      setHobby({ name: "", stars: 0 });
    }
  };
  return (
    <Paper
      elevation={3}
      style={{
        marginTop: "20px",
        marginBottom: "10px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minWidth: "48.5%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
            borderBottom: "1px solid #e1e1e1",
          }}
        >
          <h4>{getProfileLabel(props.profileLanguage, "hobbies")}</h4>
          {!editing && (
            <IconButton
              onClick={() => setEditing(true)}
              variant="outlined"
              color="primary"
            >
              <EditIcon />
            </IconButton>
          )}
          {editing && (
            <IconButton
              onClick={() => {
                setInputError({ state: false, message: "" });
                setEditing(false);
              }}
              variant="outlined"
              color="primary"
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
        {hobbies === undefined || hobbies.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {getProfileLabel(props.profileLanguage, "noHobbies")}
          </p>
        ) : (
          hobbies.map((hobby) => {
            return (
              <HobbyItem
                key={hobby._id}
                hobby={hobby}
                removeHobby={() => handleRemoveHobby(hobby)}
                editing={editing}
              />
            );
          })
        )}
      </div>
      {editing && (
        <form
          onSubmit={(e) => {
            onSubmitValidation(e);
          }}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <TextField
            error={inputError.state}
            type="text"
            name="hobby"
            label="Enter a hobby"
            value={hobby.name}
            onChange={onChange}
            className="form-cotrol"
            style={{ margin: "20px 0px 10px 0px" }}
            helperText={inputError.message}
          />
          <Button type="submit" variant="outlined" color="primary">
            Add Hobby
          </Button>
        </form>
      )}
    </Paper>
  );
};

export default Hobbies;
